export default __webpack_public_path__ + "f2dfde7dc15f166940ae7297eb6cf463.png";